/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {
    Directive,
    DoCheck,
    Input,
    IterableDiffer,
    IterableDiffers,
    OnChanges,
    SimpleChanges,
    TemplateRef,
    TrackByFunction
} from '@angular/core';

import {Items} from './providers/items';
export class DatagridItems implements OnChanges, DoCheck {
private _rawItems: any[];
/**
 * @param {?} items
 * @return {?}
 */
public set rawItems(items: any[]) {
        this._rawItems = items ? items : [];
    }
private _differ: IterableDiffer<any>;
/**
 * @param {?} template
 * @param {?} _differs
 * @param {?} _items
 */
constructor(public template: TemplateRef<any>,
private _differs: IterableDiffers,
private _items: Items) {
        _items.smartenUp();
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        if ("rawItems" in changes) {
            const /** @type {?} */ currentItems = changes.rawItems.currentValue;
            if (!this._differ && currentItems) {
                this._differ = this._differs.find(currentItems).create(this._items.trackBy);
            }
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
set trackBy(value: TrackByFunction<any>) {
        this._items.trackBy = value;
    }
/**
 * @return {?}
 */
ngDoCheck() {
        if (this._differ) {
            const /** @type {?} */ changes = this._differ.diff(this._rawItems);
            if (changes) {
                // TODO: not very efficient right now,
                // but premature optimization is the root of all evil.
                this._items.all = this._rawItems;
            }
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "[clrDgItems][clrDgItemsOf]",
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: IterableDiffers, },
{type: Items, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'rawItems': [{ type: Input, args: ["clrDgItemsOf", ] },],
'trackBy': [{ type: Input, args: ["clrDgItemsTrackBy", ] },],
};
}

function DatagridItems_tsickle_Closure_declarations() {
/** @type {?} */
DatagridItems.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridItems.ctorParameters;
/** @type {?} */
DatagridItems.propDecorators;
/** @type {?} */
DatagridItems.prototype._rawItems;
/** @type {?} */
DatagridItems.prototype._differ;
/** @type {?} */
DatagridItems.prototype.template;
/** @type {?} */
DatagridItems.prototype._differs;
/** @type {?} */
DatagridItems.prototype._items;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
